import Image from 'next/image'
import { cn } from '@/lib/utils'
import T from '@/components/Helpers/Translate'
import type { PasswordRequirementType } from '..'

export const PasswordRequirement = ({
  requirement,
}: {
  requirement: PasswordRequirementType
}) => (
  <div
    className={cn(
      'my-1 flex items-center gap-2 text-sm',
      requirement.validated && 'text-green-600',
      !requirement.validated && 'text-red-600',
    )}
  >
    <div
      className={cn(
        'transition-all',
        requirement.validated && 'scale-100',
        !requirement.validated && 'scale-0',
      )}
    >
      <Image height={20} width={20} src="/icons/check.svg" alt="Check" />
    </div>
    <p>
      <span>
        <T>{requirement.error}</T>
      </span>
    </p>
  </div>
)

export const PasswordRequirements = ({
  requirements,
}: {
  requirements: PasswordRequirementType[]
}) => {
  const requirementList = requirements?.map((requirement) => (
    <PasswordRequirement key={requirement?.error} requirement={requirement} />
  ))

  return <div className="mt-8">{requirementList}</div>
}
